import React from "react";

import "./../../css/banner.css";
import emptyImage from "./../../images/3x2.gif";

let count = 0;

export class BannerComponent extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            loaded: false
        };

        this.handleImageOnLoad = this.handleImageOnLoad.bind(this);
        this.disableContextMenu = this.disableContextMenu.bind(this);
    }

    componentDidMount() {
        // TODO
    }

    handleImageOnLoad() {
        count = count + 1;
        if (count >= 4) {
            this.setState({
                loaded: true
            });
            this.props.postLoad();
        }
    }

    disableContextMenu(event) {
        event.preventDefault();
    }

    render() {
        let tempBanner = "";
        let bannerOneClass = "banner one";
        let bannerTwoClass = "banner two";
        let bannerThreeClass = "banner three";
        let bannerFourClass = "banner four";

        if (!this.state.loaded) {
            tempBanner = <banner className="banner cover"><img src={emptyImage} alt="" /></banner>;
            bannerOneClass = bannerOneClass + " hide";
            bannerTwoClass = bannerTwoClass + " hide";
            bannerThreeClass = bannerThreeClass + " hide";
            bannerFourClass = bannerFourClass + " hide";
        }

        return (
            <section id="banner-component" onContextMenu={this.disableContextMenu} >
                <div className={bannerFourClass}><img src={emptyImage} alt="" onLoad={this.handleImageOnLoad} /></div>
                <div className={bannerThreeClass}><img src={emptyImage} alt="" onLoad={this.handleImageOnLoad} /></div>
                <div className={bannerTwoClass}><img src={emptyImage} alt="" onLoad={this.handleImageOnLoad} /></div>
                <div className={bannerOneClass}><img src={emptyImage} alt="" onLoad={this.handleImageOnLoad} /></div>
                {tempBanner}
                <div className="dummy"><img src={emptyImage} alt="" /></div>
            </section>
        );
    }

}



// WEBPACK FOOTER //
// ./src/widgets/Scroll/BannerComponent.js